export enum ChartUnit {
  undefined = 0,
  tonnesCO2E = 1,
  kilotonnesCO2E = 2,
  megatonnesCO2E = 3,
  gigatonnesCO2E = 4,
  journeys = 5,
  none = 6,
  hectares = 7,
  mills = 8,
  // US customary units
  tonnesCO2EUS = 9,
  kilotonnesCO2EUS = 10,
  megatonnesCO2EUS = 11,
  gigatonnesCO2EUS = 12,
}
